export default __webpack_public_path__ + "static/media/logo-white.a4797878.svg";